var render = function render(_c,_vm){return _c('div',{staticClass:"bulleted-list container container--narrow text-center"},[_c('ul',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }